module.exports = __webpack_public_path__ + "img/share_black.c9535446.svg";